<template>
    <div>
        <div class="d-flex align-items-center">
            <div class="box"
                 :class="[!allowBack ? 'disabled-box' : '']"
                 @click="changePage($event, 1)"
            >
                <span class="material-symbols-outlined">keyboard_double_arrow_left</span>
            </div>

            <div class="box"
                 :class="[!allowBack ? 'disabled-box' : '']"
                 @click="changePage($event, currentPage - 1)"
            >
                <span class="material-symbols-outlined">keyboard_arrow_left</span>
            </div>

            <div class="bg-white border rounded-lg div-focus border-2"
                 style="width: 70px; height: 41px; margin: 0.2rem;"
            >
                <input class="form-control border-0 py-0 shadow-none text-center"
                       type="text"
                       v-model="currentPage"
                       @change="changePage($event)"
                >
            </div>

            <div class="">of {{ totalPages }}</div>
            <div class="box"
                 :class="[!allowForward ? 'disabled-box' : '']"
                 @click="changePage($event, currentPage + 1)"
            >
                <span class="material-symbols-outlined">keyboard_arrow_right</span>
            </div>

            <div class="box"
                 :class="[!allowForward ? 'disabled-box' : '']"
                 @click="changePage($event, totalPages)"
            >
                <span class="material-symbols-outlined">keyboard_double_arrow_right</span>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: "Pagination",
    props: {
        currentPageProp: {type: Number, required: true},
        totalPages: {type: Number, required: true}
    },
    data() {
        return {
            currentPage: this.currentPageProp,
            allowForward: true,
            allowBack: false
        }
    },
    mounted() {
        this.refresh();
    },
    methods: {
        changePage(e, newPage) {
            if (newPage < 1 ||
                newPage > this.totalPages ||
                newPage == this.currentPage
            ) {
                return;
            }
            newPage = newPage ? newPage : this.currentPage;
            newPage = parseInt(newPage);
            this.currentPage = newPage;
            this.refresh();
            this.$emit('change-page', newPage);
            if (this.$parent && this.$parent.$parent && typeof this.$parent.$parent.changePage === 'function') {
                this.$parent.$parent.changePage(newPage);
            }
        },
        refresh() {
            this.allowForward = this.currentPage < this.totalPages;
            this.allowBack = this.currentPage > 1;
        }
    }
}

</script>

<style scoped>
.box {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    margin: 0.2rem;
    border-radius: 0.5rem;
    border: 2px solid #843468;
    color: #843468;
    cursor: pointer;
}
.box:not(.disabled-box):hover {
    border-color: rgba(132, 52, 104, 0.88);
    color: rgba(132, 52, 104, 0.88);
}
.disabled-box {
    border-color: gray;
    color: gray;
}

</style>
